import { render } from "./add-bank.vue?vue&type=template&id=4a2a16ba"
import script from "./add-bank.vue?vue&type=script&lang=js"
export * from "./add-bank.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__